import { Component } from "@angular/core";
import { MatIcon } from "@angular/material/icon";

@Component({
    templateUrl: './client-portal-client-deactivated-task.component.html',
    styleUrls: ['./client-portal-client-deactivated-task.component.scss'],
    imports: [MatIcon]
})
export class ClientPortalClientDeactivatedTaskComponent {}
